<template>
  <!-- <div id="workbench"></div> -->
  <div id="author-revised">
    <div class="ipub-h2 line-h-40  mar-b-12">
      <div v-if="disableStatu">
        Author Revision - <font>{{termList[reviewsResponse.decisionStatus]}}</font>
      </div>
      <div v-else>Submitted Decision</div>
      <!-- {{disableStatu ? 'Author Revision' : 'Submitted Decision'}} -->
    </div>

    <div class="content-bg mar-b-20"
         style="padding-bottom:4px">
      <div class="mar-b-20">
        <div class="ipub-title-tab mar-b-10 ipub-h3 line-h-40">Manuscript Information</div>
        <div class="ipub-title-tab-part ipub-p2">
          <div class="mar-b-10">
            <span class="ipub-block__span fw-bd">Article Title</span>
            <span class="ipub-block__font">{{reviewsResponse.details && reviewsResponse.details.title}}</span>
          </div>
          <div class="mar-b-10">
            <span class="ipub-block__span fw-bd">Journal</span>
            <span class="ipub-block__font">{{reviewsResponse.journal && reviewsResponse.journal.fullName}}</span>
          </div>
          <div class="mar-b-10">
            <span class="ipub-block__span fw-bd">Manuscript No.</span>
            <span class="ipub-block__font">{{reviewsResponse.code}}</span>
          </div>
          <div class="mar-b-10">
            <span class="ipub-block__span fw-bd">Article Type</span>
            <span class="ipub-block__font">{{reviewsResponse.details&&reviewsResponse.details.type.name}}</span>
          </div>
          <div class="flex mar-b-10"
               v-if="downloadAttachment && downloadAttachment.length">
            <span class="ipub-block__span fw-bd"
                  style="line-height:30px">Attachment(s)</span>
            <div class="ipub-block__font">
              <ipub-label size="small"
                          class="ipub-c-p ipub-p2"
                          style="align-items: center;height:30px;margin:0 12px 10px 0"
                          type="link"
                          v-for="(item,index) in downloadAttachment"
                          :key="item.id"
                          @click="download(item,index)">
                {{item.name}}
                <ipub-icon class="mar-l-10 ipub-p2"
                           type="iconDownload1" />
              </ipub-label>
            </div>
          </div>
          <div>
            <span class="ipub-block__span fw-bd">Discount</span>
            <span class="ipub-block__span fw-bd"
                  style="line-height:30px">
              <template v-if="reviewsResponse && reviewsResponse.discountDetailList &&reviewsResponse.discountDetailList.length>0">
                <font>{{reviewsResponse.__diacountTotal}} USD off</font>
              </template>
              <template v-else>- -</template></span>
          </div>
        </div>
      </div>

      <div>
        <div class="ipub-h3 mar-b-12 ipub-title-tab  line-h-40"
             @click="()=>{showEditor = !showEditor}"
             v-show="reviewsResponse.authorNotes || (reviewsResponse.editorFileList && reviewsResponse.editorFileList.length>0) || ((reviewsResponse.reviewReportList && reviewsResponse.reviewReportList.length>0) || reviewsResponse.macademicId)">
          {{reviewsResponse.decisionType==='FINAL_DECISION' ? 'Editor Decision': 'Academic Editor Decision'}}
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showEditor?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-show="showEditor">
          <div class="mar-b-20">
            <div class="ipub-p2 fw-bd fw-bd mar-b-8"
                 @click="()=>{showCommment = !showCommment}">
              Comments to Author
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',showCommment?'rotate-180':'']"
                         type="iconArrow" />
            </div>
            <div v-show="showCommment">
              <div class="ipub-p2"
                   v-if="reviewsResponse.authorNotes"
                   v-html="reviewsResponse.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              <template v-else>
                <div class="line-color">No notes or comments.</div>
              </template>
            </div>

          </div>
          <div class="mar-b-10"
               v-show="reviewsResponse.editorFileList && reviewsResponse.editorFileList.length>0">
            <div class="ipub-p2 fw-bd fw-bd relative mar-b-12">
              Attachment(s)
            </div>
            <div class="mar-b-20 ipub-p2">
              <ipub-label v-for="(item, index) in reviewsResponse.editorFileList"
                          style="margin-right:8px"
                          class="ipub-p2 ipub-c-p"
                          type="link"
                          :key="item.name"
                          @click="download(item,index)">
                {{item.name}}
                <ipub-icon class="mar-l-10"
                           type="iconDownload1" />
              </ipub-label>
            </div>
          </div>
          <div v-if="(reviewsResponse.reviewReportList && reviewsResponse.reviewReportList.length>0) || reviewsResponse.macademicId">
            <div v-if="reviewsResponse.decisionType!='FINAL_DECISION'">
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd fw-bd mar-b-8">
                  Response to Academic editor's comments
                  <font class="key-color"
                        v-if="reviewsResponse.authorNotes">*</font>
                </div>
                <ipub-textarea v-model="params.authorReplyMacademic.authorReply"
                               :autoSize="{ cols: '8', rows: '6' }"
                               placeholder="Enter response details to academic editor’s comments…" />
              </div>
              <div class="mar-b-30">
                <div class="flex mar-b-12"
                     v-show="disableStatu">
                  <div class="ipub-p2 fw-bd">Attachment(s)</div>
                  <!-- v-show="disableStatu" -->
                  <div class="ipub-p2 tr mar-l-20">
                    <ipub-upload v-if="disableStatu&&!loading"
                                 @change="handleUpload1">
                      <a class="link-color">
                        <ipub-icon type="iconAdd" /> Add New Attachment(s)
                      </a>
                    </ipub-upload>
                    <font class="line-color"
                          v-else>
                      <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Attachment(s)
                    </font>
                  </div>
                </div>
                <div class="mar-b-20 ipub-p2">
                  <ipub-label class="mar-b-12 ipub-p2 ipub-c-p"
                              style="margin-right:10px;height:30px"
                              v-for="(item,index) in params.authorReplyMacademic.authorReplyFileList"
                              :key="item.id">
                    <a class="border-right ipub-p2"
                       @click="download(item)">
                      {{item.name}}
                      <ipub-icon class="mar-l-10"
                                 type="iconDownload1" />
                    </a>
                    <ipub-icon class="mar-l-10"
                               @click="delFile(index)"
                               type="iconDelete" />
                  </ipub-label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="reviewsResponse.authorNotes">
            <div v-if="reviewsResponse.decisionType==='FINAL_DECISION'">
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd fw-bd mar-b-8">
                  Response to Editor's Comments
                  <font class="key-color"
                        v-if="reviewsResponse.authorNotes">*</font>
                </div>
                <ipub-textarea v-model="params.authorReplyMeditor.authorReply"
                               :autoSize="{ cols: '8', rows: '6' }"
                               placeholder="Enter response details to editor’s comments…" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mar-b-10"
           v-if="reviewsResponse.decisionType!='PRE_CHECK' && reviewsResponse.reviewReportList && reviewsResponse.reviewReportList.length>0">
        <div class="ipub-h3  mar-b-12 ipub-title-tab  line-h-40"
             @click="()=>{showReviewer = !showReviewer}">
          Reviewer Decision
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showReviewer?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-show="showReviewer">
          <li class="flex ipub-line-block ipub-border mar-b-12"
              v-for="(item,index) in reviewsResponse.reviewReportList"
              :key="'review'+index">
            <p class="ipub-p2 fw-bd"
               style="width:130px">Reviewer {{item.seq}}</p>
            <a class="ipub-p2 fw-bd"
               @click="replay(item)">
              <font class="link-color">
                <ipub-icon type="iconViewDetails" />
                View Report
                <template v-if="item.replyed">(Already Reply)</template>
                <font class="key-color"
                      v-else>(Please upload your point-to-point response to reviewer)</font>
              </font>
            </a>
          </li>
        </div>
      </div>

      <div class=""
           v-if="disableStatu">
        <div class="ipub-h3  mar-b-12 ipub-title-tab  line-h-40"
             @click="()=>{showResubmit = !showResubmit}">
          Submit Revised Manuscript
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showResubmit?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-if="showResubmit"
             class="ipub-title-tab-part">
          <ipub-row :gutter="30">
            <ipub-col :span="6"
                      v-for="item in fileTypes"
                      :key="item.id">
              <div class="mar-b-30">
                <div class="mar-b-4 ipub-p2 fw-bd relative">
                  {{item.typeName}}
                  <font v-if="item.required"
                        class="key-color">*</font>
                  <ipub-tooltip placement="right"
                                type="dark"
                                class="mar-l-10">
                    <div slot="title">Supported file types: {{item.typeFile}}
                      <div v-if="item.typeName==='Figure'">Please upload as ZIP file for more than one figure.</div>
                      <div v-if="item.typeName==='Video'">Please upload as ZIP file for more than one video.</div>
                      <div v-if="item.typeName==='Supplementary File'">Please upload as ZIP file for more than one supplementary file.</div>
                    </div>
                    <ipub-icon type="iconInfo" />
                  </ipub-tooltip>
                  <!-- <div class="right-option">
                    <ipub-upload v-if="!item.file"
                                 @change="(e)=>{handleUpload(item, e)}"
                                 class="mar-b-16">
                      <a class="link-color">Add</a>
                    </ipub-upload>
                    <font class="line-color"
                          v-else>Add</font>
                  </div> -->
                </div>
                <div class="ipub-line-block ipub-border relative">
                  <div style="width: calc(100% - 60px)">
                    <a @click="download(item.file)"
                       v-if="item.file.name">{{item.file.name}}</a>
                    <ipub-upload v-else
                                 class="ipub-c-p"
                                 style="width:100%"
                                 @change="(e)=>{handleUpload(item, e)}">
                      <a class="line-color">Click here to upload {{item.typeName}}</a>
                    </ipub-upload>
                  </div>
                  <div class="right-option ipub-p2 flex"
                       v-if="item.file.name"
                       style="right: 10px">
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Replace
                      </div>
                      <ipub-upload v-if="true"
                                   class="line-h-40"
                                   @change="(e)=>{handleUpload(item, e)}">
                        <a>
                          <ipub-icon style="font-size:16px"
                                     type="iconReplace" />
                        </a>
                      </ipub-upload>
                    </ipub-tooltip>
                    <div style="padding: 0 4px"
                         class="line-color line-h-40">|</div>
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Delete
                      </div>
                      <a class="line-h-40"
                         @click="del(item)">
                        <ipub-icon style="font-size:16px"
                                   type="iconDelete" />
                      </a>
                    </ipub-tooltip>
                  </div>
                </div>
              </div>
            </ipub-col>
          </ipub-row>
        </div>
      </div>

      <div v-if="disableStatu">
        <div class="ipub-h3  mar-b-10 ipub-title-tab line-h-40"
             @click="()=>{showFunding = !showFunding}">
          Funding Information
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showFunding?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-if="showFunding">
          <ipub-radio :checked="hasFoun"
                      class="mar-b-10 ipub-p2 fw-bd"
                      @change="onHasFunChange"
                      label="I have received funding" />
          <div class="mar-b-30"
               v-if="hasFoun">
            <div class="ipub-p2 mar-b-10 font-color"
                 style="letter-spacing: 0px;">
              Funding data is used by funders to track result from research grants. IMR press can contribute to improve information for funders by depositing metadata through <a class="link-color"
                 href="https://www.crossref.org/education/funder-registry/">Crossref</a>.
            </div>
            <div>
              <div class="mar-b-10">
                <div class="ipub-p2 fw-bd">Funder</div>
                <ipub-row>
                  <ipub-col>
                    <ipub-input v-model.trim="foundation.name"
                                :select="founds"
                                @input="getFound"
                                @select="onFoundationChange"
                                optionKey="name"
                                placeholder="Select exist funder in the list or enter your funder name" />
                  </ipub-col>
                </ipub-row>
              </div>
              <div>
                <div class="ipub-p2 fw-bd">Grant Number</div>
                <div class="flex mar-b-20">
                  <ipub-input placeholder="Enter your grant number"
                              v-model.trim="foundation.code"
                              style="width:calc(100% - 105px);margin-right:10px" />
                  <ipub-button type="primary"
                               style="width:105px"
                               @click="AddFoun">
                    <!-- <ipub-icon :class="['ipub-p5']"
                           type="iconAdd">
                </ipub-icon> -->
                    Save
                  </ipub-button>
                </div>
              </div>
              <div>
                <ipub-label :style="{margin: '0 16px 16px 0'}"
                            class="ipub-p2"
                            v-for="(item, index) in params.foundationList"
                            :key="'detail.keywords'+index"
                            size="common"
                            cover
                            circle>
                  {{item.name}}<template v-if="item.code">({{item.code}})</template>
                  <a @click="delFoun(index)"
                     class="mar-l-20">
                    <ipub-icon type="iconClose" />
                  </a>
                </ipub-label>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mar-b-20">
      <ipub-button type="primary"
                   style="width:230px"
                   plain
                   @click="()=>{$router.back(-1)}">
        Cancel
      </ipub-button>
      <ipub-button style="width:230px;"
                   @click="submit"
                   type="primary">Confirm & Submit</ipub-button>
    </div>

    <Loading :isVisable="loading"
             @cancel="cancel"
             :ftype="ftype"
             :hasUploadFiles="hasUploadFiles"
             :progress="uploadProgress" />

  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
</style>
